<div class="search-input">
  <mat-form-field floatLabel="never" appearance="fill">
    <mat-icon matPrefix>search</mat-icon>
    <input type="search" #searchInput  matInput placeholder="Buscar..." (keyup)="search.emit($event.target['value'].toLowerCase())">
    <button mat-button *ngIf="searchInput.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchInput.value=''; search.emit(searchInput.value.toLowerCase())">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
